<template>
    <v-layout column>
        <v-toolbar dense flat style="background: none" class="authors">
            <v-toolbar-title class="pl-1 body-1">{{label}}</v-toolbar-title>
            <v-dialog
                    v-model="dialog"
                    persistent
                    scrollable
                    width="650"
            >
                <v-btn flat icon color="primary" slot="activator"
                       @click="()=>{ editIdx=null; Object.assign(item,freshItem); user={name:''}; }">
                    <v-icon>add</v-icon>
                </v-btn>
                <v-card>
                    <v-card-text>
                        <v-form v-model="formValid" ref="formRef">
                            <v-container>
                                <v-layout row wrap>

                                    <v-flex xs8>
                                        <x-user-select-form
                                                label="作者姓名"
                                                v-model="user"
                                                :rules="rules.name"
                                        />
                                    </v-flex>

                                    <v-flex xs4>
                                        <v-select
                                                label="作者排名"
                                                :items="validRanks"
                                                v-model="item.rank"
                                                :rules="rules.required"
                                        />
                                    </v-flex>

                                    <v-flex xs6>
                                        <v-text-field
                                                label="完成字数"
                                                v-model="item.wordCount"
                                                :rules="rules.wordCount"
                                                hint="单位：万字"
                                                persistent-hint
                                        />
                                    </v-flex>

                                    <v-flex xs6>
                                        <v-select
                                                label="作者类别"
                                                clearable
                                                required
                                                :rules="rules.required"
                                                v-model="item.typeId"
                                                item-text="name"
                                                item-value="dbid"
                                                :items="typeItems"
                                        />
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-text-field
                                                label="作者部门或单位"
                                                v-model="item.deptName"
                                                :rules="rules.name"
                                                counter="150"
                                                :disabled="item.userId && item.userId.length > 0"
                                        />
                                    </v-flex>

                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-divider/>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat @click.native="dialog = false">取消</v-btn>
                        <v-btn color="primary" @click.native="onOk">确定</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-toolbar>

        <v-data-table
                class="dense"
                :headers="headers"
                :items="value"
                hide-actions
        >
            <template slot="items" slot-scope="props">
                <td>{{props.item.rank}}</td>
                <td>{{props.item.name}}</td>
                <td>{{props.item.wordCount ? props.item.wordCount : ''}}</td>
                <td>{{props.item.deptName ? props.item.deptName : '' }}</td>
                <td>{{ (typeItems.find(v => v.dbid === props.item.typeId) || {name:''}).name }}</td>
                <td class="justify-center layout px-0">
                    <v-tooltip top>
                        <v-btn icon class="mx-0" slot="activator"
                               @click="onEdit(props.index, props.item)">
                            <v-icon color="teal">edit</v-icon>
                        </v-btn>
                        <span>编辑</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <v-btn icon class="mx-0" slot="activator"
                               @click="onDel(props.index)">
                            <v-icon color="pink">delete</v-icon>
                        </v-btn>
                        <span>删除</span>
                    </v-tooltip>
                </td>
            </template>
        </v-data-table>
    </v-layout>
</template>
<script>
    import XUserSelectForm from '@/components/global/UserSelectForm'

    const typeURI = '/api/book/author-type';

    export default {
        name: 'bookAuthors',
        props: ['value', 'label', 'hint'],
        components: {XUserSelectForm},

        data() {
            return {

                headers: [
                    {text: '排序', sortable: false, value: 'rank', width: 18},
                    {text: '姓名', sortable: false, value: 'name'},
                    {text: '完成字数', sortable: false, value: 'wordCount'},
                    {text: '单位或部门', sortable: false, value: 'deptName'},
                    {text: '类别', sortable: false, value: 'type'},
                    {text: '操作', sortable: false, value: 'dbid'}
                ],

                dialog: false,
                freshItem: {
                    userId: null,
                    name: null,
                    rank: null,
                    deptName: null,
                    wordCount: null,
                    typeId: null,
                },
                item: {},

                editIdx: null,

                user: {
                    userId: null,
                    name: null,
                    deptName: null,
                },

                formValid: false,

                rankItems: [
                    1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
                    11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
                    21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
                    31, 32, 33, 34, 35, 36, 37, 38, 39, 40
                ],

                typeItems: [],

                rules: {
                    name: [
                        v => !!v || '必填项。',
                        v => (v && v.length <= 150) || '长度必须小于150个字符。'
                    ],
                    required: [
                        v => !!v || '必填项。'
                    ],
                  wordCount: [
                    v => !v || /^\d+(\.\d{1,2})?$/.test(v) || '填写整数或小数,小数点后最多两位。'
                  ]
                }
            }
        },

        created() {
            this.axios.get(typeURI, {params: {limit: 65535, disabled: 'F', sort: 'order.asc'}})
                .then(rspType => {
                    this.typeItems = rspType.data.items;
                })
        },

        watch: {
            user: function (u) {
                Object.assign(this.item, u);
            }
        },

        computed: {
          /*validRanks() {
            if (this.value) {
              const rr = this.value.map(v => v.rank);
              return this.rankItems.filter(v => !rr.includes(v));
            }
            return this.rankItems;
          }*/

          validRanks() {
            if (this.value) {
              const rr = this.value.map(v => v.rank);

              // 如果是编辑模式，需要保留当前编辑项的排名值
              if (this.editIdx !== null && this.item && this.item.rank) {
                // 创建一个新数组，包含所有可用的排名和当前编辑项的排名
                return this.rankItems.filter(v => !rr.includes(v) || v === this.item.rank);
              }

              // 如果是新增模式，只过滤掉已使用的排名
              return this.rankItems.filter(v => !rr.includes(v));
            }
            return this.rankItems;
          },
        },

        methods: {
            onEdit(idx, it) {
                window.console.log("编辑")
                this.editIdx = idx;
                this.item = window.xutil.clone(it);
                window.console.log(this.item)
                this.user.userId = this.item.userId;
                this.user.name = this.item.name;
                this.user.deptName = this.item.deptName;
                this.dialog = true;
            },
            onOk() {
                if (this.$refs.formRef.validate()) {
                    let authors = window.xutil.clone(this.value);

                    if (this.editIdx != null) {
                        authors[this.editIdx] = window.xutil.clone(this.item);
                    } else {
                        authors.push(window.xutil.clone(this.item));
                    }

                    authors.sort((a, b) => a.rank - b.rank);
                    this.$emit('input', authors);
                    this.dialog = false;
                }
            },

            onDel(idx) {
                this.$emit('input', this.value.filter((v, i) => i !== idx))
            }
        }

    }
</script>
<style>
    .authors.v-toolbar > .v-toolbar__content {
        padding-left: 0;
    }
</style>

